module.exports = __webpack_public_path__ + "static/media/Seta_fechada.0f5ecf86.svg";